import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';

export class ImageDisplay {
    content: string;
    isIcon: boolean;
    constructor(content: string, isIcon: boolean = false) {
        this.content = content;
        this.isIcon = isIcon;
    }
}

@Component({
    selector: 'mx-image-carousel',
    templateUrl: './mx-image-carousel.component.html',
    standalone: false,
    styleUrl: './mx-image-carousel.component.scss',
    animations: [
        trigger('carousalAnimation', [
            transition(':enter', [
                style({ transform: 'translateX(-100%)' }),
                animate(
                    '1000ms ease-in',
                    style({
                        transform: 'translateX(0%)',
                    })
                ),
            ]),
            transition(':leave', [
                animate(
                    '1000ms ease-in',
                    style({
                        transform: 'translateX(-100%)',
                    })
                ),
            ]),
        ]),
    ],
})
export class MxImageCarouselComponent implements OnInit {
    @Input() images: ImageDisplay[] = [];
    @Input() indicators = true;
    @Output() selectedIndexChange = new EventEmitter<number>();
    selectedIndex = 0;
    constructor() {}

    ngOnInit(): void {
        this.autoSlideImages();
    }

    isInlineImage(content: string): boolean {
        return !!content?.startsWith('data:');
    }

    selectImage(index: number, event: MouseEvent): void {
        event.stopPropagation();
        this.selectedIndex = index;
        this.selectedIndexChange.emit(index);
    }

    autoSlideImages(): void {
        setInterval(() => {
            this.selectedIndex < this.images.length - 1
                ? this.selectedIndex++
                : (this.selectedIndex = 0);
            this.selectedIndexChange.emit(this.selectedIndex);
        }, 7000);
    }
}
